export const getDomainGradientStyle = (isPrimary: boolean) => {
  const firstColor = isPrimary ? '#00A651' : '#B41D8D'
  const secondColor = isPrimary ? '#00B6AD' : '#F79A6C'

  return `background:radial-gradient(120% 100% at 50% 10%, transparent 56%, ${firstColor} 80%, ${secondColor} 96%);`
}